export const uiInitialState = {
  cargando: false,
  error: "",
};

export const TypeInitialState = {
  list: [],
};
